import React, { useCallback, useEffect, useRef, useState } from 'react';
import './NotificationLoginPopup.css';

const AUTO_CLOSE_MS = 8000;
const POPUP_CLOSE_MS = 320;

export default function NotificationLoginPopup({ notifications, onDismiss }) {
    const [exitingIds, setExitingIds] = useState(() => new Set());
    const scheduledRef = useRef(new Set());
    const closeTimersRef = useRef([]);

    const dismissWithAnimation = useCallback((id) => {
        setExitingIds((prev) => {
            if (prev.has(id)) return prev;
            const next = new Set(prev);
            next.add(id);
            return next;
        });

        const timer = setTimeout(() => {
            onDismiss(id);
            setExitingIds((prev) => {
                const next = new Set(prev);
                next.delete(id);
                return next;
            });
            scheduledRef.current.delete(id);
        }, POPUP_CLOSE_MS);

        closeTimersRef.current.push(timer);
    }, [onDismiss]);

    useEffect(() => {
        const autoTimers = [];

        notifications.forEach((notification) => {
            if (scheduledRef.current.has(notification.id)) return;
            scheduledRef.current.add(notification.id);

            const timer = setTimeout(() => {
                dismissWithAnimation(notification.id);
            }, AUTO_CLOSE_MS);

            autoTimers.push(timer);
        });

        return () => autoTimers.forEach(clearTimeout);
    }, [notifications, dismissWithAnimation]);

    useEffect(() => () => {
        closeTimersRef.current.forEach(clearTimeout);
        closeTimersRef.current = [];
    }, []);

    if (!notifications.length) return null;

    return (
        <div className="notification-login-popups" aria-live="polite">
            {notifications.map((notification) => (
                <div
                    key={notification.id}
                    className={`notification-login-popup${
                        exitingIds.has(notification.id) ? ' notification-login-popup--closing' : ''
                    }`}
                >
                    <button
                        type="button"
                        className="notification-login-popup-close"
                        onClick={() => dismissWithAnimation(notification.id)}
                        aria-label="Cerrar"
                    >
                        ×
                    </button>
                    <p className="notification-login-popup-label">Notificación para tu local</p>
                    <h4 className="notification-login-popup-title">{notification.title}</h4>
                    <p className="notification-login-popup-description">{notification.description}</p>
                </div>
            ))}
        </div>
    );
}
